(() => {
    window.Dashboard = window.Dashboard || {};

    window.Dashboard.Models = window.Dashboard.Models || {};

    class CustomerWorkflowTypes {
        /**
         * @type {number}
         */
        Id = undefined;

        /**
         * @type {string}
         */
        Name = undefined;

        /**
         * @type {boolean}
         */
        HasCommunication = false;
    }

    window.Dashboard.Models.CustomerWorkflowTypes = CustomerWorkflowTypes;
})();
